"use client"

import Cookies from 'js-cookie';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function CookeiSetter({ cookies }: { cookies: string[] }) {
const router = useRouter()
    useEffect(() => {
        if (cookies.length > 0) {
            if (cookies[1]) {
                Cookies.set(cookies[0], cookies[1])
            } else {
                Cookies.remove(cookies[0])
                router.refresh()
            }
        }
    }, [cookies.length])

    return (
        <>

        </>
    );
}